import { Link } from "react-router-dom";

export default function TFDSelectNationalTours() {
	return (
		<div className="tfd-select-national-tours">
			{/* Hero */}
			<section className="tf-hero-national-tours">
				<div className="hero-image-wrap">
					<img
						src="/images/select/national-hero.jpg"
						alt="National Tours Hero"
						className="hero-bg-image"
					/>
					<div className="overlay-dark" />
					<div className="hero-content themeflat-container">
						<h1 className="hero-title wow fadeInUp animated">National Tours</h1>
						<p className="hero-subtitle wow fadeInUp animated">
							Show your skills on a bigger stage!
						</p>
						<Link to="/contact" className="flat-button wow fadeInUp animated">
							Get Info
						</Link>
					</div>
				</div>
			</section>

			{/* Info */}
			<section className="tf-national-info main-content">
				<div className="themeflat-container">
					<div className="row align-items-center">
						<div className="col-md-6 wow fadeInLeft animated">
							<img
								src="/images/select/national-tours.jpg"
								alt="National Tours"
								style={{ borderRadius: "8px", marginBottom: "30px" }}
							/>
						</div>
						<div className="col-md-6 wow fadeInRight animated">
							<div className="title-box title-small-v2">
								<span className="sub-title">TFD SELECT</span>
								<h2 className="title-section">National-Level Competition</h2>
							</div>
							<p>
								TFD’s National Tours give players the chance to face top-level
								competition across Australia, experiencing new challenges and
								environments.
							</p>
							<p>
								<strong>Next tour details coming soon!</strong>
								<br />
								If you want updates or to express interest, contact us below.
							</p>
							<Link to="/contact" className="flat-button">
								Contact Us
							</Link>
						</div>
					</div>
				</div>
			</section>
		</div>
	);
}
